import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { PaginatedResponse, PaginationParams } from '../../../core/shared/models/pagination.model';
import { ParticipanteDomainModel } from '../models/participante.model';
import { ParticipantesFiltro } from '../models/participantes-filtro.model';
import { ParticipanteDetalhamento } from '../models/participante-detalhamento.model';
import { FinalizarEtapaResponse } from '../models/finalizar-etapa-response.model';
import { ReabrirEtapaResponse } from '../models/reabrir-etapa-response.model';
import { ProrrogarEtapaResponse } from '../models/prorrogar-etapa-response.model';
import {
  AceitarProcessoResponse,
  BusResponse,
  CancelarProcessoResponse,
  EstadoProcessoResponse,
  GerarProcessoRequest,
  NovaPropostaResponse,
  VerificarElegibilidadeResponse,
  VerificarMatriculasResponse
} from '../models/processo-manual.model';
import {
  ConsultarPerguntasPropostaResponse,
  PerguntasPropostaRequest,
  PerguntasPropostaResponse
} from '../models/proposta-manual.model';
import { VendedorProposta } from '../../proposta-financiamento/models/dados-proposta.model';

export const PARTICIPANTE_REPOSITORY = new InjectionToken<ParticipanteRepository>('ParticipanteRepository');

export interface ParticipanteRepository {
  listarTodos(
    filtros?: ParticipantesFiltro,
    params?: PaginationParams
  ): Observable<PaginatedResponse<ParticipanteDomainModel>>;
  listarCabecalho(matricula: number): Observable<ParticipanteDetalhamento>;
  estadoProcesso(cpf: string): Observable<EstadoProcessoResponse>;
  verificarElegibilidade(cpf: string | null, matricula?: number | null): Observable<VerificarElegibilidadeResponse>;
  gerarProcesso(request: GerarProcessoRequest): Observable<BusResponse<NovaPropostaResponse>>;
  aceitarProcesso(proposta: number): Observable<AceitarProcessoResponse>;
  cancelarProcesso(proposta: number, condominio: number | null): Observable<CancelarProcessoResponse>;
  finalizarEtapa(idProposta: string, idEtapa: string): Observable<FinalizarEtapaResponse>;
  reabrirEtapa(idProposta: string, idEtapa: string, justificativa?: string): Observable<ReabrirEtapaResponse>;
  prorrogarEtapa(idProcesso: string, idEtapa: string, qtdDiasProrrogados: number, mensagemJustificativa: string): Observable<ProrrogarEtapaResponse>;
  verificarMatriculas(cpf: string): Observable<VerificarMatriculasResponse>;
  enviarPerguntasPropostaManual(proposta: number, request: PerguntasPropostaRequest): Observable<PerguntasPropostaResponse>;
  consultarPerguntasPropostaManual(proposta: number): Observable<ConsultarPerguntasPropostaResponse>;
  recuperarDadosVendedorPropostaManual(cpf: string): Observable<VendedorProposta>;
}


